import {TemplateSchema} from "./Template";

export const AlertSchema = {
    name: 'name',
    description: 'description',
    logId: 'logId',
    severity: 'severity',
    severityValues: {
        emergency: 'EMERGENCY',
        alert: 'ALERT',
        critical: 'CRITICAL',
        error: 'ERROR',
        warning: 'WARNING',
        notice: 'NOTICE',
        info: 'INFO',
        debug: 'DEBUG'
    },
    filter: 'filter',
    isAtLeast: 'isAtLeast',
    threshold: 'threshold',
    isSameSource: 'isSameSource',
    timeInterval: 'timeInterval',
    isSendMail: 'isSendMail',
    data: 'data',
    dataSchema: TemplateSchema
}